<form [formGroup]="list" [id]="id">
    @for (item of list.controls; track item; let i = $index) {
        <div class="sh-form-row-with-action" style="margin-bottom: 0">
            <div class="sh-form-row-with-action__inputs">
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-select-base
                        [formControl]="getTypeControl(i)"
                        [id]="getTypeId(i)"
                        [options]="types"
                        [placeholderMsg]="typePlaceholderMsg"
                        [isDisabled]="disabled"
                        class="sh-form-group__input"
                    ></sh-form-select-base>
                </div>
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-autocomplete [autocompleteFct]="autocompleteStreams[i] | async">
                        <input
                            type="text"
                            autocomplete="off"
                            [formControl]="getValueControl(i)"
                            [id]="getValueId(i)"
                            [attr.placeholder]="valuePlaceholderMsg || null"
                            [attr.disabled]="disabled ? true : null"
                            class="sh-form-group__input sh-input-field"
                        />
                    </sh-autocomplete>
                </div>
                @if (actionItems) {
                    <div class="sh-form-row-with-action__actions">
                        @for (actionItem of actionItems[i]; track actionItem) {
                            <sh-action-item class="sh-form-row-with-action__actions__item" [item]="actionItem"></sh-action-item>
                        }
                    </div>
                }
            </div>
        </div>
    }
</form>
@if (isIndeterminate && indeterminateMsg) {
    <p class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
}
